'use client';

import { Link } from 'react-router-dom';
import styles from '../ProductDetail.module.css';

export function AkustikSungerHubContent() {
  return (
    <div className={styles.seoWrap}>
      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Sünger Nedir?</h2>
        <p className={styles.seoText}>
          Akustik sünger, kapalı alanlarda oluşan yankıyı, çınlamayı ve ses yansımalarını azaltmak amacıyla
          kullanılan açık hücreli yapıya sahip ses emici bir malzemedir. Poliüretan veya melamin esaslı olarak
          üretilir. Yüzeyi piramit, yumurta, labirent veya düz formda işlenebilir. Oda içinde konuşulan ses,
          müzik veya makine gürültüsü duvar, tavan ve zeminden yansıdığında kulakta bulanık ve yorucu bir
          etki oluşur. Akustik sünger bu yansımaları emerek oda içi ses kalitesini iyileştirir.
        </p>
        <p className={styles.seoText}>
          BariyerliBondexSunger.com olarak Echopan markasıyla sunduğumuz akustik sünger modelleri stüdyo,
          ofis, eğitim kurumu ve konut projelerinde yıllardır kullanılmaktadır. Ürünlerimiz açık hücre
          yapısı sayesinde orta ve yüksek frekanslı sesleri etkili biçimde absorbe eder. Ses yalıtım
          malzemesi değildir. Komşu daireden gelen sesi kesmek için{' '}
          <Link to="/bondex-sunger" rel="follow">
            Bondex sünger
          </Link>{' '}
          veya bariyerli bondex modelleri ayrıca değerlendirilmelidir.
        </p>

        <p className={styles.seoText}>
          Akustik sünger ile ses yalıtım süngeri aynı şey değildir. Piyasada her iki terim de birbirinin
          yerine kullanılsa da teknik olarak farklıdır. Ses yalıtım süngeri denildiğinde çoğu zaman yüksek
          yoğunluklu bondex sünger kastedilir. Akustik sünger ise oda akustiğini düzenleyen emici bir
          malzemedir. İkisini doğru tanımlamak doğru ürün seçiminin temelidir.
        </p>
        <p className={styles.seoText}>
          Malzeme rengi genelde siyah, gri veya koyu tonlarda üretilir. Renk seçimi çoğunlukla estetik
          kaygıdan gelir, emilim performansını doğrudan etkilemez. Yüzey profili ve kalınlık performansı
          belirler. Echopan akustik sünger ürünlerimiz fabrika çıkışlı kontrol sürecinden geçer. Her parti
          yoğunluk ve kalınlık açısından tutarlıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Akustik Sünger Sesi Nasıl Emer?</h3>
        <p className={styles.seoText}>
          Ses dalgası akustik süngerin gözenekli yüzeyine çarptığında hücreler arasında ilerler. Bu sırada
          hava molekülleri sürtünerek ses enerjisi ısıya dönüşür. Açık hücre yapısı ne kadar düzenli ve
          yoğunsa emilim o kadar verimli olur. Düz yüzeyli paneller geniş alanlarda temel emilim sağlarken
          profilli yüzeyler sesi farklı açılardan dağıtarak daha geniş frekans bandında çalışır.
        </p>
        <p className={styles.seoText}>
          Emilim performansı NRC değeriyle ölçülür. NRC 0.85 ve üzeri değerler profesyonel uygulamalar için
          yeterli kabul edilir. Kalınlık arttıkça özellikle düşük frekanslarda emilim güçlenir. 20 mm
          ince modeller hafif yankı kontrolü sunarken 40-50 mm kalın modeller stüdyo ve kayıt odalarında
          tercih edilir. Yüzey profili de emilimi etkiler.{' '}
          <Link to="/akustik-piramit-sunger" rel="follow">
            Piramit akustik sünger
          </Link>{' '}
          üç boyutlu yüzeyiyle sesi dağıtarak geniş frekans aralığında çalışır.
        </p>

        <p className={styles.seoText}>
          Emilim verimliliği frekansa göre değişir. İnce paneller yüksek frekanslarda iyi çalışır. Kalın
          paneller ve köşe uygulamaları düşük frekanslara yaklaşır. Tam frekans dengesi için farklı kalınlık
          ve profillerin bir arada kullanılması önerilir. Tek tip panel ile her frekansta mükemmel sonuç
          beklemek gerçekçi değildir.
        </p>

        <h3 className={styles.seoSubtitle}>Akustik Sünger Yankıyı Azaltır mı?</h3>
        <p className={styles.seoText}>
          Evet. Akustik süngerin temel görevi yankıyı azaltmaktır. Boş ve sert yüzeyli odalarda konuşma
          veya müzik yansıyarak çınlama yapar. Sünger paneller bu yansımaları emdiğinde reverberasyon
          süresi kısalır. Kulak daha net ses algılar. Stüdyo kayıtlarında yankısız ortam elde etmek,
          toplantı salonunda konuşmanın anlaşılır kalması ve restoranda gürültünün kontrol altına alınması
          bu prensiple çalışır.
        </p>
        <p className={styles.seoText}>
          Yankı kontrolünde tüm yüzeyleri kaplamak gerekmez. İlk yansıma noktaları ve arka duvarlar
          öncelikli hedeflenir. Yanlış uygulamada oda tamamen susturulmuş hissi verebilir. Bu nedenle
          dengeli bir kaplama planı yapılmalıdır. Teknik ekibimiz metraj ve hedefe göre yüzde kaç alanın
          kaplanması gerektiğini belirler.
        </p>

        <p className={styles.seoText}>
          RT60 olarak bilinen reverberasyon süresi ölçümle takip edilir. Profesyonel stüdyolarda hedef RT60
          değeri oda hacmine göre hesaplanır. Akustik sünger kaplama oranı bu hedefe göre ayarlanır. Ev
          kullanıcıları için ölçüm şart değildir ancak dengeli kaplama ilkesi her projede geçerlidir.
        </p>

        <h3 className={styles.seoSubtitle}>Akustik Düzenleme mi Sağlar Ses Yalıtımı mı Sağlar?</h3>
        <p className={styles.seoText}>
          Akustik sünger akustik düzenleme sağlar, ses yalıtımı sağlamaz. Akustik düzenleme oda içindeki
          sesin kalitesini iyileştirir. Yankı, çınlama ve yansıma kontrol altına alınır. Ses yalıtımı ise
          bir odadan diğerine ses geçişini engellemeyi hedefler. Duvar, tavan veya zemin katmanları arasına
          yerleştirilen yüksek yoğunluklu malzemelerle yapılır.
        </p>
        <p className={styles.seoText}>
          Bu iki kavram sık karıştırılır. Akustik süngeri duvar arkasına koyarak komşu sesini kesmeye
          çalışmak yanlış bir uygulamadır. Oda içinde duvar yüzeyine yapıştırıldığında yankı azalır ancak
          duvar arkasından ses geçişi devam eder. Hem yankı kontrolü hem komşu sesi engelleme gerekiyorsa
          önce bondex veya bariyerli bondex ile yalıtım katmanı, üzerine akustik sünger ile iç yüzey
          düzenlemesi yapılır. İki işlem birbirini tamamlar.
        </p>
        <p className={styles.seoText}>
          Pratik bir örnek vermek gerekirse stüdyo odasında yankıyı azaltmak için duvarlara akustik sünger
          yapıştırılır. Aynı odanın dışına ses gitmesini engellemek için ise duvar karkası içine bondex
          sünger yerleştirilir. İki uygulama farklı katmanlarda yapılır. Sadece akustik sünger ile dışarı
          ses sızdırmamak mümkün değildir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Sünger Nerelerde Kullanılır?</h2>
        <p className={styles.seoText}>
          Akustik sünger her türlü kapalı hacimde yankı ve gürültü kontrolü için kullanılır. Mekanın
          boyutu, kullanım amacı ve mevcut yüzey malzemesi uygulama planını belirler. Aşağıdaki alanlar
          en sık talep edilen kullanım senaryolarıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Müzik stüdyoları</h3>
        <p className={styles.seoText}>
          Kayıt ve miks odalarında yankısız ortam şarttır. Mikrofon her yansımayı kayda alır. Kontrol
          odasında da doğru dinleme ortamı oluşturmak için akustik sünger kullanılır. Stüdyolarda genelde
          duvarların yüzde 40-60 ı ve tavanın bir bölümü kaplanır. Köşelere bass trap yerleştirilerek düşük
          frekanslar da hedeflenir.{' '}
          <Link to="/akustik-yumurta-sunger" rel="follow">
            Yumurta sünger
          </Link>{' '}
          stüdyo duvarlarında yaygın tercih edilen profildir.
        </p>
        <p className={styles.seoText}>
          Stüdyo projelerinde difüzör ve absorber birlikte planlanır. Tüm yüzeyi süngerle kaplamak bas
          frekanslarda sorun yaratabilir. Bu nedenle profesyonel stüdyolarda farklı malzeme tipleri bir
          arada kullanılır. Echopan teknik ekibi stüdyo metrajınızı değerlendirerek profil ve kalınlık
          önerisi sunar.
        </p>

        <h3 className={styles.seoSubtitle}>Podcast ve yayın odaları</h3>
        <p className={styles.seoText}>
          Podcast ve radyo yayın odalarında küçük hacimde bile yankı kayıt kalitesini düşürür. Konuşmacının
          arkasına ve yan duvarlara akustik panel yerleştirmek yeterli olabilir. Küçük odalarda aşırı
          kaplama sesi boğuk yapabilir. Bu nedenle yüzde 25-35 oranında dengeli uygulama önerilir.
          Kendinden yapışkanlı modeller hızlı kurulum sağlar.
        </p>
        <p className={styles.seoText}>
          Yayın odalarında masa arkası ve yan duvarlar öncelikli hedeflenir. Tavan genelde küçük odalarda
          atlanabilir ancak yüksek tavanlı odalarda tavan panelleri de gerekir. Mikrofonun yakaladığı oda
          tonu kayıt kalitesini doğrudan etkiler. Doğru kaplama ile post prodüksiyonda EQ düzeltmesine
          daha az ihtiyaç duyulur.
        </p>

        <h3 className={styles.seoSubtitle}>Ev sinema sistemleri</h3>
        <p className={styles.seoText}>
          Ev sinema odasında hoparlörden çıkan ses duvar ve tavandan yansıyarak film deneyimini bozar.
          Özellikle arka duvar ve yan yansıma noktalarına sünger yerleştirmek surround sesin netliğini
          artırır. Sinema odalarında genelde koyu renkli paneller tercih edilir. Işık yansımasını azaltmak
          için mat yüzeyli{' '}
          <Link to="/akustik-duz-sunger" rel="follow">
            düz akustik sünger
          </Link>{' '}
          modelleri de kullanılabilir.
        </p>
        <p className={styles.seoText}>
          Ev sinema odasında ön duvar genelde ekran ve hoparlör için ayrılır. Yan ve arka duvarlar akustik
          sünger ile kaplanır. Bas performansı için köşelere kalın bass trap eklenebilir. Sinema odası
          akustiği film ve müzik dinleme deneyimini doğrudan iyileştirir.
        </p>

        <h3 className={styles.seoSubtitle}>Ofis ve toplantı salonları</h3>
        <p className={styles.seoText}>
          Açık ofislerde ve cam bölmeli toplantı odalarında ses yansıması konuşmayı zorlaştırır. Tavan
          panelleri ve duvar uygulamaları gürültüyü yönetir. Video konferans yapılan odalarda karşı
          taraftan gelen yankı sorununu da azaltır. Kurumsal projelerde yangına dayanıklı E sınıfı
          ürünler tercih edilir.
        </p>
        <p className={styles.seoText}>
          Cam bölmeli toplantı odalarında ses cam yüzeyden yansır. Bölme üstü ve tavan uygulaması gizlilik
          sağlar. Açık ofiste tavan asma panelleri en verimli çözümdür. Çalışanlar arası ses taşması
          azalır, telefon görüşmeleri daha rahat yapılır.
        </p>

        <h3 className={styles.seoSubtitle}>Çağrı merkezleri</h3>
        <p className={styles.seoText}>
          Çağrı merkezlerinde onlarca operatör aynı anda konuşur. Tavan akustik panelleri ve bölme
          üstlerine uygulanan süngerler gürültü seviyesini düşürür. Operatörlerin birbirini duyması
          azalır, müşteri görüşmeleri daha net yapılır.{' '}
          <Link to="/akustik-labirent-sunger" rel="follow">
            Labirent desenli sünger
          </Link>{' '}
          geniş tavan alanlarında hem estetik hem performans sunar.
        </p>
        <p className={styles.seoText}>
          Çağrı merkezlerinde gürültü seviyesi çalışan sağlığını etkiler. İş sağlığı ve güvenliği
          düzenlemeleri belirli gürültü sınırları öngörür. Akustik sünger tek başına yasal sınırın altına
          indirmeyebilir ancak reverberasyonu azaltarak algılanan gürültüyü düşürür. Kulaklık kullanımı
          ile birlikte daha konforlu çalışma ortamı oluşur.
        </p>

        <h3 className={styles.seoSubtitle}>Eğitim kurumları</h3>
        <p className={styles.seoText}>
          Sınıf, dershane, üniversite amfi ve kütüphanelerde yankı öğrenme ortamını olumsuz etkiler.
          Öğretmenin sesi duvarlardan yansıyarak öğrencilere bulanık ulaşır. Tavan ve arka duvar
          uygulamaları konuşma anlaşılırlığını artırır. Okul projelerinde yangın sertifikası zorunlu
          tutulur.           Echopan akustik sünger modellerimiz bu gereksinimi karşılar.
        </p>
        <p className={styles.seoText}>
          Kütüphane ve okuma salonlarında sessizlik beklentisi yüksektir. Yankılı ortamda fısıltı bile
          rahatsız edici uzunlukta duyulur. Tavan panelleri ve duvar uygulamaları bu alanlarda standart
          çözümdür. Okul koridorlarında ise ses yalıtımı ile akustik düzenleme farklı katmanlarda ele
          alınmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Restoran ve kafeler</h3>
        <p className={styles.seoText}>
          Restoran ve kafelerde sert zemin, cam ve beton yüzeyler yankıyı artırır. Müşteriler yüksek
          sesle konuşmaya başlar, ortam gürültülü hale gelir. Tavan panelleri ve duvar uygulamaları
          reverberasyon süresini kısaltır. Mekan daha konforlu hissedilir. Estetik açıdan renk ve profil
          seçimi dekorasyonla uyumlu yapılabilir.
        </p>
        <p className={styles.seoText}>
          Yüksek tavanlı restoranlarda asma tavan ve akustik panel kombinasyonu sık kullanılır. Açık
          mutfaklı mekanlarda pişirme sesi de yansır. Mutfak ile salon arasında fiziksel bariyer varsa
          akustik sünger salon tarafında yankıyı kontrol eder. Müşteri deneyimi ve personel konforu için
          akustik yatırım uzun vadede işletmeye katkı sağlar.
        </p>

        <h3 className={styles.seoSubtitle}>Fabrika ve üretim alanları</h3>
        <p className={styles.seoText}>
          Geniş hacimli fabrika ve üretim salonlarında makine gürültüsü duvar ve çatıdan yansır. Akustik
          sünger tek başına iş güvenliği sınırının altına indirmek için yeterli olmayabilir. Ancak ofis
          bölmesi, kontrol odası ve dinlenme alanlarında yankı kontrolü için etkili çalışır. Yüksek
          sıcaklık ve nemli ortamlarda uygun yapıştırıcı ve kaplama seçimi önemlidir.
        </p>
        <p className={styles.seoText}>
          Fabrika ofisleri ve dinlenme odaları üretim alanından ayrı değerlendirilmelidir. Kontrol odasında
          operatörler makine sesinden etkilenmemeli. Bu odalarda akustik sünger yankıyı azaltarak iletişimi
          kolaylaştırır. Üretim hattının kendisinde ise kulaklık, bariyer ve yapısal yalıtım birlikte
          planlanır.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Sünger Çeşitleri</h2>
        <p className={styles.seoText}>
          Akustik sünger tek bir standart formla üretilmez. Yüzey profili, emilim karakteristiğini ve
          görünümü belirler. Echopan olarak piramit, yumurta, labirent, düz ve bass trap formlarında
          ürün sunuyoruz. Her profil farklı mekan ve frekans ihtiyacına hitap eder.
        </p>

        <h3 className={styles.seoSubtitle}>Piramit akustik sünger</h3>
        <p className={styles.seoText}>
          Piramit yüzeyli akustik sünger, üç boyutlu çıkıntılı yapısıyla sesi farklı açılardan emer.
          Orta ve yüksek frekanslarda güçlü performans sunar. Stüdyo, kayıt odası ve müzik provası
          alanlarında en çok tercih edilen profildir. Görsel olarak da tek düze duvarlara hareket katar.
          Detaylı bilgi için{' '}
          <Link to="/akustik-piramit-sunger" rel="follow">
            piramit akustik sünger
          </Link>{' '}
          sayfamızı inceleyebilirsiniz.
        </p>
        <p className={styles.seoText}>
          Piramit derinliği ve yoğunluğu emilim karakterini etkiler. Sığ piramit görsel olarak hafif
          kalır, derin piramit daha agresif emilim sunar. Stüdyo kontrol odasında genelde orta derinlik
          tercih edilir. Kayıt odasında daha yoğun kaplama yapılabilir.
        </p>

        <h3 className={styles.seoSubtitle}>Yumurta sünger</h3>
        <p className={styles.seoText}>
          Yumurta desenli sünger, yarım küre şeklindeki çıkıntılarıyla sesi dağıtır. Piramide göre daha
          yumuşak bir görünüm sunar. Yayın odası, podcast stüdyosu ve ev müzik odalarında sık kullanılır.
          Geniş frekans bandında dengeli emilim sağlar.{' '}
          <Link to="/akustik-yumurta-sunger" rel="follow">
            Akustik yumurta sünger
          </Link>{' '}
          modellerimiz farklı kalınlık seçenekleriyle stoktan temin edilir.
        </p>
        <p className={styles.seoText}>
          Yumurta profili ısı haritası gibi dairesel desen oluşturur. Bu desen odaya yumuşak bir görünüm
          verir. Sert hatlı piramit profil istemeyen mekanlarda yumurta tercih edilir. Emilim performansı
          piramide yakındır, seçim çoğunlukla estetik kaygıya dayanır.
        </p>

        <h3 className={styles.seoSubtitle}>Labirent desenli sünger</h3>
        <p className={styles.seoText}>
          Labirent profilli sünger, girintili çıkıntılı yüzeyiyle geniş alanlarda etkili emilim sunar.
          Tavan uygulamalarında ve geniş ofis alanlarında tercih edilir. Ses dalgasının yüzeyde daha uzun
          yol almasını sağlar. Estetik açıdan modern mekanlara uyum sağlar.{' '}
          <Link to="/akustik-labirent-sunger" rel="follow">
            Labirent akustik sünger
          </Link>{' '}
          sayfasında teknik detayları bulabilirsiniz.
        </p>
        <p className={styles.seoText}>
          Labirent profili geniş yüzeylerde monoton görünümü kırar. Ofis ve çağrı merkezi tavanlarında
          sık kullanılır. Ses dalgası girinti ve çıkıntılar arasında yön değiştirerek enerji kaybeder.
          Düz panele göre daha yüksek birim alan emilimi sağlar.
        </p>

        <h3 className={styles.seoSubtitle}>Düz akustik sünger</h3>
        <p className={styles.seoText}>
          Düz yüzeyli akustik sünger, sade görünüm isteyen projelerde kullanılır. Geniş duvar alanlarında
          homojen kaplama sağlar. Sinema odası, galeri ve minimalist ofislerde tercih edilir. Profilli
          modellere göre birim alan başına daha ekonomik olabilir.{' '}
          <Link to="/akustik-duz-sunger" rel="follow">
            Düz akustik sünger
          </Link>{' '}
          seçeneklerimiz 20 ile 50 mm kalınlık aralığında üretilir.
        </p>
        <p className={styles.seoText}>
          Düz sünger üzerine kumaş kaplama veya ahşap çerçeve ile panel görünümü verilebilir. Bu yöntem
          konut projelerinde sık kullanılır. Ham sünger görünümü istenmeyen mekanlarda kaplama tercih
          edilir. Emilim performansı kaplama kalınlığına göre hafif değişebilir.
        </p>

        <h3 className={styles.seoSubtitle}>Bass trap akustik sünger</h3>
        <p className={styles.seoText}>
          Bass trap, oda köşelerine yerleştirilen kalın ve yoğun akustik sünger elemanlarıdır. Düşük
          frekanslı sesleri hedefler. Stüdyo ve kayıt odalarında piramit veya yumurta panellerle birlikte
          kullanılır. Köşe birikimi nedeniyle bas frekanslar orada yoğunlaşır. Bass trap bu birikimi
          absorbe eder. Genelde 50 mm ve üzeri kalınlıkta, yüksek yoğunluklu olarak üretilir.
        </p>
        <p className={styles.seoText}>
          Bass trap üç boyutlu köşe elemanı veya duvar ile tavan birleşimine yerleştirilen kalın panel
          olarak uygulanır. Stüdyo projelerinde duvar panelleri ile birlikte sipariş edilir. Düz duvar
          paneli düşük frekansta yetersiz kalır, köşe uygulaması bu açığı kapatır.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Doğru Akustik Sünger Nasıl Seçilir?</h2>
        <p className={styles.seoText}>
          Doğru akustik sünger seçimi projenin başarısını belirler. Yanlış profil veya kalınlık hem
          maliyet hem performans kaybına yol açar. Aşağıdaki kriterleri değerlendirmenizi öneririz.
        </p>

        <h3 className={styles.seoSubtitle}>Kullanım alanına göre seçim</h3>
        <p className={styles.seoText}>
          Stüdyo ve kayıt odası için piramit veya yumurta profil, geniş ofis tavanı için labirent, sade
          görünümlü konut uygulaması için düz sünger uygun olur. Restoran ve kafede hem performans hem
          estetik önemlidir. Renk ve profil mekan dekorasyonuyla uyumlu seçilmelidir. Kullanım alanını
          net tanımlamak doğru ürüne ulaşmanın ilk adımıdır.
        </p>
        <p className={styles.seoText}>
          Küçük oda ile büyük hacim aynı ürünle çözülmez. 10 m² podcast odası ile 200 m² çağrı merkezi
          farklı kaplama oranı ve profil gerektirir. Teknik ekibimize oda ölçüsü ve kullanım amacını
          ilettiğinizde ücretsiz yönlendirme alabilirsiniz.
        </p>
        <p className={styles.seoText}>
          Nemli ortamlar için nem dayanımlı yapıştırıcı ve kaplama seçimi gerekir. Yüzme havuzu kenarı
          veya spa alanında özel ürün talep edilmelidir. Standart akustik sünger yüksek nemde formunu
          korur ancak yapışma ve hijyen açısından farklı değerlendirme yapılır.
        </p>

        <h3 className={styles.seoSubtitle}>Kalınlığın performansa etkisi</h3>
        <p className={styles.seoText}>
          Kalınlık arttıkça emilim kapasitesi yükselir. 20 mm hafif yankı kontrolü için yeterli olabilir.
          30 mm çoğu ofis ve konut uygulamasında dengeli seçimdir. 40-50 mm stüdyo, sinema odası ve
          yüksek performans gerektiren alanlarda tercih edilir. Çok ince sünger düşük frekanslarda
          yetersiz kalır. Çok kalın sünger küçük odada aşırı sönümleme yapabilir.
        </p>
        <p className={styles.seoText}>
          Kalınlık seçiminde oda hacmi kritik öneme sahiptir. 15 m² odada 50 mm paneller boğuk ses
          üretebilir. 40 m² ve üzeri odalarda 40-50 mm daha dengeli çalışır.{' '}
          <Link to="/akustik-piramit-sunger" rel="follow">
            Piramit akustik sünger
          </Link>{' '}
          30 mm kalınlıkta en çok satılan kombinasyondur.
        </p>

        <h3 className={styles.seoSubtitle}>Yoğunluk neden önemlidir?</h3>
        <p className={styles.seoText}>
          Yoğunluk kg/m³ cinsinden ifade edilir. Yüksek yoğunluklu sünger daha dayanıklıdır ve düşük
          frekanslarda daha iyi çalışır. Düşük yoğunluklu sünger hafiftir ancak zamanla toz tutabilir
          ve formunu kaybedebilir. Profesyonel projelerde 25-35 kg/m³ aralığı yaygındır. Bass trap
          uygulamalarında daha yüksek yoğunluk gerekir.
        </p>

        <h3 className={styles.seoSubtitle}>Profesyonel ve bireysel kullanım farkları</h3>
        <p className={styles.seoText}>
          Profesyonel stüdyo projelerinde NRC değeri, yangın sertifikası ve frekans bazlı emilim raporu
          talep edilir. Bireysel ev uygulamalarında pratik montaj ve görünüm ön plandadır. Profesyonel
          projelerde özel kesim ve yerleşim planı hazırlanır. Bireysel siparişlerde standart 100x100 cm
          plakalar kargo ile gönderilir. Her iki segmentte de WhatsApp hattımızdan destek alınabilir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Süngerin Sağladığı Avantajlar Nelerdir?</h2>

        <h3 className={styles.seoSubtitle}>Daha net konuşma kalitesi</h3>
        <p className={styles.seoText}>
          Yankı azaldığında konuşma heceleri birbirine karışmaz. Toplantı odasında herkes birbirini
          daha net duyar. Eğitim ortamında öğretmenin sesi sınıfın her noktasına eşit ulaşır. Video
          konferansta karşı taraf da net ses alır.
        </p>

        <h3 className={styles.seoSubtitle}>Daha dengeli ses dağılımı</h3>
        <p className={styles.seoText}>
          Stüdyo ve sinema odalarında sesin oda içinde eşit dağılması önemlidir. Yansıma noktalarına
          yerleştirilen paneller ilk yansımayı kontrol altına alır. Dinleme pozisyonunda frekans
          dengesizliği azalır. Miks ve mastering kararları daha güvenilir verilir.
        </p>

        <h3 className={styles.seoSubtitle}>Yankının kontrol altına alınması</h3>
        <p className={styles.seoText}>
          Reverberasyon süresi kısaldığında ortam gürültüsü algısı düşer. Restoran ve kafede müşteriler
          daha alçak sesle konuşur. Açık ofiste dikkat dağınıklığı azalır. Kayıt ortamında yankısız
          ses elde edilir.{' '}
          <Link to="/akustik-piramit-sunger" rel="follow">
            Piramit sünger
          </Link>{' '}
          yankı kontrolünde en etkili profillerden biridir.
        </p>

        <h3 className={styles.seoSubtitle}>Konforlu çalışma ve yaşam alanları</h3>
        <p className={styles.seoText}>
          Gürültülü ve yankılı ortam uzun süreli çalışmada yorucudur. Akustik düzenleme yapılmış odada
          konsantrasyon artar. Ev sinema deneyimi iyileşir. Müzik pratiği komşuları rahatsız etmeden
          yapılabilir. Çalışan memnuniyeti ve verimlilik üzerinde olumlu etki görülür.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Sünger Ölçüleri ve Kalınlık Seçenekleri</h2>

        <h3 className={styles.seoSubtitle}>En çok tercih edilen ebatlar</h3>
        <p className={styles.seoText}>
          Standart plaka ölçüsü 100x100 cm dir. Bu ebat kargo ve montaj açısından pratiktir. 50x50 cm
          yarım plaka küçük alanlar ve patch uygulamaları için kullanılır. Büyük projelerde özel ebat
          kesim yapılabilir. Sipariş öncesi duvar veya tavan metrajı hesaplanmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>20 mm, 30 mm, 40 mm ve 50 mm seçenekleri</h3>
        <p className={styles.seoText}>
          20 mm ince detay ve hafif yankı kontrolü için uygundur. 30 mm ev ve ofis projelerinde en
          çok satılan kalınlıktır. 40 mm stüdyo ve sinema odalarında tercih edilir. 50 mm yüksek
          performans ve bass trap uygulamalarında kullanılır. Kalınlık seçimi oda hacmi ve hedef NRC
          değerine göre belirlenir.{' '}
          <Link to="/akustik-duz-sunger" rel="follow">
            Düz sünger
          </Link>{' '}
          modellerinde tüm kalınlık seçenekleri mevcuttur.
        </p>

        <h3 className={styles.seoSubtitle}>Özel üretim ölçüler</h3>
        <p className={styles.seoText}>
          Standart ölçü dışında proje bazlı kesim yapıyoruz. Eğri duvar, sütun sarma ve tavan kasası
          gibi özel detaylar için CNC kesim hizmeti sunulur. Özel üretim siparişlerinde minimum metraj
          şartı uygulanabilir. Teknik çizim paylaşıldığında kesim listesi ve fiyat teklifi aynı gün
          hazırlanır.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Sünger Montajı Nasıl Yapılır?</h2>

        <h3 className={styles.seoSubtitle}>Uygulama öncesi yüzey hazırlığı</h3>
        <p className={styles.seoText}>
          Yüzey temiz, kuru ve tozdan arındırılmış olmalıdır. Gevşek boya, yağ ve nem yapışmayı
          zayıflatır. Beton yüzeyde gerekirse astar uygulanır. Alçıpan yüzeyde düzgünlük kontrol edilir.
          Tavan uygulamasında yüzeyin taşıyıcı özelliği değerlendirilir. Ağır modellerde mekanik
          sabitleme eklenir.
        </p>

        <h3 className={styles.seoSubtitle}>Yapıştırıcı seçimi</h3>
        <p className={styles.seoText}>
          Akustik sünger için solvent içermeyen özel yapıştırıcı kullanılır. Genel amaçlı silikon veya
          solvent bazlı yapıştırıcılar süngeri eritebilir. Sprey yapıştırıcı büyük alanlarda pratiktir.
          Tubu yapıştırıcı küçük parçalar için uygundur. Kendinden yapışkanlı modellerde arka yüz
          koruma bandı kaldırılarak doğrudan yapıştırılır.
        </p>

        <h3 className={styles.seoSubtitle}>Doğru yerleşim planı</h3>
        <p className={styles.seoText}>
          Tüm yüzeyi kaplamak her zaman doğru değildir. İlk yansıma noktaları hoparlör veya konuşmacı
          hizasında belirlenir. Arka duvar ve tavan merkezi öncelikli hedeflenir. Stüdyoda mirror
          point hesabı yapılır. Ofiste tavan panelleri ve arka duvar yeterli olabilir.{' '}
          <Link to="/akustik-yumurta-sunger" rel="follow">
            Yumurta profil
          </Link>{' '}
          ilk yansıma noktalarında sık kullanılır.
        </p>

        <h3 className={styles.seoSubtitle}>Profesyonel montaj önerileri</h3>
        <p className={styles.seoText}>
          Paneller arasında 2-5 mm boşluk bırakmak genleşmeye izin verir. Köşe birleşimlerinde bass
          trap yerleştirmek düşük frekans performansını artırır. Montaj sonrası oda akustiği ölçümle
          doğrulanabilir. Büyük projelerde profesyonel montaj ekibi ile çalışmak zaman ve malzeme
          israfını önler.           Echopan montaj kılavuzu siparişle birlikte gönderilir.
        </p>
        <p className={styles.seoText}>
          Dikey duvar uygulamasında yapıştırıcı hem süngere hem duvara uygulanır. 30 saniye bekledikten
          sonra panel yerine bastırılır. Tavan uygulamasında geçici destek veya bant ile sabitleme
          yapılır, yapıştırıcı kuruyana kadar panel düşmemesi sağlanır. Hatalı montaj performansı
          düşürür, malzeme israfına yol açar.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Sünger İçin Neden Bizimle Çalışmalısınız?</h2>
        <p className={styles.seoText}>
          BariyerliBondexSunger.com olarak Echopan markasıyla yıllardır ses yalıtım ve akustik düzenleme
          alanında hizmet veriyoruz. Akustik sünger stoklarımız Türkiye genelinden aynı gün kargo ile
          gönderilir. Tüm modellerimiz yangın sertifikalıdır. Teknik ekibimiz proje bazlı yerleşim planı
          ve metraj hesabı yapar.
        </p>
        <p className={styles.seoText}>
          Piramit, yumurta, labirent ve düz profillerde geniş ürün yelpazesi sunuyoruz. 20 ile 50 mm
          arası kalınlık seçenekleri stoktan temin edilir. Özel kesim ve kurumsal proje desteği veriyoruz.
          WhatsApp hattımızdan hızlı fiyat teklifi alabilirsiniz. Müşteri memnuniyeti odaklı çalışıyoruz.
          Sorularınız için teknik destek hattımız hafta içi aktiftir.
        </p>
        <p className={styles.seoText}>
          Bondex sünger ve bariyerli bondex ürünlerimizle birlikte komple akustik çözüm sunabiliyoruz.
          Hem yalıtım hem yankı kontrolü gereken projelerde tek tedarikçi avantajı sağlıyoruz.{' '}
          <Link to="/akustik-labirent-sunger" rel="follow">
            Labirent sünger
          </Link>{' '}
          ve diğer profiller hakkında detaylı bilgi için ilgili ürün sayfalarımızı ziyaret edebilirsiniz.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Sünger Hakkında Sık Sorulan Sorular</h2>

        <h3 className={styles.seoSubtitle}>Akustik sünger sesi tamamen keser mi?</h3>
        <p className={styles.seoText}>
          Hayır. Akustik sünger oda içindeki yankıyı azaltır, sesi tamamen kesmez. Komşu duvarından gelen
          sesi engellemek için bondex veya bariyerli bondex kullanılmalıdır. İki malzeme farklı işlev
          görür.
        </p>

        <h3 className={styles.seoSubtitle}>Evde kullanılabilir mi?</h3>
        <p className={styles.seoText}>
          Ev sinema odası, müzik odası, çalışma odası ve hatta yatak odasında kullanılabilir. Yangına
          dayanıklı E sınıfı modellerimiz konut uygulamalarına uygundur. Kendinden yapışkanlı versiyonlar
          ev kullanıcıları için pratik montaj sağlar.
        </p>

        <h3 className={styles.seoSubtitle}>Yangına dayanıklı modeller var mı?</h3>
        <p className={styles.seoText}>
          Evet. Stoklarımızdaki tüm akustik sünger modelleri TS EN 13501-1 standardına göre E sınıfı
          yanmazlık sertifikasına sahiptir. Okul, hastane ve ticari proje taleplerinde sertifika kopyası
          paylaşılır.
        </p>

        <h3 className={styles.seoSubtitle}>Her duvara uygulanabilir mi?</h3>
        <p className={styles.seoText}>
          Alçıpan, beton, tuğla ve ahşap yüzeylere uygun yapıştırıcı ile uygulanır. Nemli veya tozlu
          yüzeylerde önce yüzey düzeltilmelidir. Çok pürüzlü betonda düzeltme şartı gerekebilir.
        </p>

        <h3 className={styles.seoSubtitle}>Tavanda kullanılabilir mi?</h3>
        <p className={styles.seoText}>
          Tavanda yaygın olarak kullanılır. Hafif paneller yapıştırıcı ile sabitlenir. Ağır veya büyük
          plakalarda mekanik ankraj eklenmesi önerilir. Tavan uygulamasında yerleşim planı özellikle
          önemlidir.
        </p>

        <h3 className={styles.seoSubtitle}>Tek başına ses yalıtımı sağlar mı?</h3>
        <p className={styles.seoText}>
          Tek başına ses yalıtımı sağlamaz. Akustik düzenleme malzemesidir. Duvar arkasından ses geçişini
          engellemek için yapısal yalıtım katmanları gerekir. Bondex sünger duvar karkası içinde bu
          işlevi görür.
        </p>

        <h3 className={styles.seoSubtitle}>Ne kadar alan kaplanmalıdır?</h3>
        <p className={styles.seoText}>
          Stüdyo ve kayıt odalarında duvar ve tavan alanının yaklaşık yüzde 30-50 si kaplanır. Ofis ve
          toplantı salonlarında yüzde 20-30 yeterli olabilir. Oda boyutu ve hedef akustik seviyeye göre
          plan yapılır. Teknik ekibimizden metraj önerisi alabilirsiniz.
        </p>

        <h3 className={styles.seoSubtitle}>Akustik sünger ömrü ne kadardır?</h3>
        <p className={styles.seoText}>
          Doğru montaj ve normal kullanım koşullarında 10 yıl ve üzeri performans korunur. Doğrudan güneş
          ışığına maruz kalan veya fiziksel darbe alan yüzeylerde erken yıpranma görülebilir. Toz
          birikimi performansı hafif düşürebilir, periyodik temizlik yeterlidir.
        </p>
      </section>
    </div>
  );
}
